import $http from '../../../../../axios-instance';

/**
 * Obtener la palabra asociadas al producto.
 *
 * @param Object commit
 * @param Object params -> { productId, versionId, languageId }
 * @return void
 */
export async function getSubCategoriesWordOfCautionByProduct({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit('resetWordOfCautionSga');        
    try {

        const { data: response } = await $http.get(`/products/sga2/word-of-caution`, { params });
        commit('setWordOfCautionSga', response.data);        
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}